import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { FaChevronLeft } from "react-icons/fa";

interface ItemDeMenu {
    titulo: string;
    icone?: React.ElementType;
}

interface SubmenuAcaoLoteProps<T extends ItemDeMenu> {
    acao: T & { subAcoes?: T[] };
    executar: (acao: T) => void;
}

export function SubmenuAcaoLote<T extends ItemDeMenu>({ acao, executar }: SubmenuAcaoLoteProps<T>) {
    const [aberto, setAberto] = useState(false);
    const Icone = acao.icone;

    return (
        <div className="relative" onMouseEnter={() => setAberto(true)} onMouseLeave={() => setAberto(false)}>
            <div
                className={`dropdown-item cursor-pointer ${aberto ? "bg-gray-100" : ""}`}
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", whiteSpace: "nowrap" }}
                onClick={(e) => { e.stopPropagation(); setAberto(v => !v); }}
            >
                <span style={{ display: "inline-flex", alignItems: "center", gap: "12px" }}>
                    {Icone && (
                        <span className="text-[#1F467E]" style={{ display: "inline-flex", alignItems: "center" }}>
                            <Icone className="w-4 h-4" />
                        </span>
                    )}
                    <span>{acao.titulo}</span>
                </span>
                <FaChevronLeft className="text-gray-500" style={{ width: 10, height: 10, flexShrink: 0 }} />
            </div>
            {aberto && (
                <div
                    className="bg-white border border-gray-200 rounded-md shadow-lg py-1"
                    style={{ position: "absolute", right: "100%", top: 0, marginRight: 2, minWidth: 180, zIndex: 1100 }}
                >
                    {(acao.subAcoes ?? []).map((sub, indice) => {
                        const IconeSub = sub.icone;
                        return (
                            <Dropdown.Item key={indice} onClick={() => executar(sub)}>
                                <div className="flex items-center gap-3">
                                    {IconeSub && (
                                        <span className="text-[#1F467E] flex items-center justify-center">
                                            <IconeSub className="w-4 h-4" />
                                        </span>
                                    )}
                                    <span>{sub.titulo}</span>
                                </div>
                            </Dropdown.Item>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
